module.exports = __webpack_public_path__ + "img/xz2.3ef617ec.png";